import RequestHandler from "./RequestHandler";

function ScannersAPI() {
    const baseScannersAPI = "scanners";

    const listScanners = async (
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) => {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "DESC";
            const URL = `${baseScannersAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = RequestHandler.post(URL, filters);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    const createScanner = async (payload) => {
        try {
            const result = await RequestHandler.post(baseScannersAPI, payload);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    const updateScanner = async (payload) => {
        try {
            const result = await RequestHandler.put(baseScannersAPI, payload);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    const removeScanner = async (scannerId) => {
        try {
            const result = await RequestHandler.remove(
                `${baseScannersAPI}/${scannerId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    const getScannerByName = async (scannerName) => {
        try {
            const result = await RequestHandler.get(
                `${baseScannersAPI}/${scannerName}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    const updateBulkScanners = async (payload) => {
        try {
            const result = await RequestHandler.put(
                `${baseScannersAPI}/bulk`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    return {
        listScanners,
        createScanner,
        updateScanner,
        removeScanner,
        getScannerByName,
        updateBulkScanners,
    };
}

export default ScannersAPI();
